import Joi from "joi";

export const departmentValidationSchema = Joi.object({
  status: Joi.boolean().required().messages({
    "boolean.pattern.base": "Status is required.",
    "boolean.empty": "Status is required.",
    "any.invalid": "Status is required.",
  }),
  deptName: Joi.string().min(2).max(100).required().messages({
    "string.empty": "Department Name is required.",
    "string.max": "Department Name must not exceed 100 characters.",
    "string.min": "Department name must be at least 2 characters.",
    "any.required": "Department Name is required.",
  }),
});
